<!-- eslint-disable -->
<template>
  <div v-if="isInitiailized" class="G_modal_container">
    <div class="G_modal" :class="{ G_hidden_element: activeModal!='default'}">
      <modal-header
        @event-close-child-modals="eventCloseChildModals"
        @event-close-modal="selfClose"
        :title="modalTitle">
      </modal-header>
      <hr>
      <div class="c3m1_main_container">
        <div class="c3m1_buttons_container">
          <div class="c3m1_buttons_row_1">
            <button 
              v-if="userPermissions.includes('a') || userPermissions.includes('u')"
              class="c3m1_buttons c3m1_manage_rules_button" 
              @click.stop="showManageRules"
            ></button>
          </div>
          <div class="c3m1_buttons_row_2">
            <div class="p2s1_search_area">
              <i class="p2s1_search_icon fa fa-search"></i>
              <input class="p2s1_input" placeholder="Support comma seperated emails." v-model.trim="DV_commaSeparatedUserEmails" type="text">
              <button class="p2s1_clear_search_icon p2s1_clear_btn" @click.stop="clearSearch" value="X"></button>
            </div>
            <div class="c3m1_buttons_mobile">
              <button 
                class="c3m1_buttons c3m1_add_user_button" 
                @click.stop="addCommaSeparatedUsersToGroup"
              ></button> 
              <button 
                class="c3m1_buttons c3m1_find_user_button" 
                @click.stop="filterUsersList"
              ></button>
            </div>
          </div>
        </div>
        <div class="c3m1_user_lists_area">
          <div class="c3m1_assigned_users_section">
            <h3 class="c3m1_assigned_users_heading"> ({{C_assignedUsersCount}})</h3>
            <div class="c3m1_users_list" v-if="!DV_isLoadingGroupUsersJoin && !DV_isLoadingUsers">
              <span 
                v-for="user in DV_usersList"
                v-if="user.assigned == true"
                class="c3m1_user_list_entry c3m2_assigned_user_list_entry" 
              >
                <span>{{user.email}}</span>
                <i @click.stop="removeUserFromGroup(user)" class="fa fa-times-circle c3m1_remove_user_icon c3m1_remove_icon"></i>
              </span>
            </div>
            <div v-else class="c3m1_users_list">
              <beat-loader :loading="true" :color="C_loaderColor" :height="'50px'" :width="'50px'"></beat-loader>
            </div>
          </div>
          <div class="c3m1_available_users_section">
            <h3 class="c3m1_available_users_heading"> ({{C_availableUsersCount}})</h3>
            <div class="c3m1_users_list" v-if="!DV_isLoadingGroupUsersJoin && !DV_isLoadingUsers">
              <span 
                v-for="user in DV_usersList"
                v-if="user.assigned == false"
                class="c3m1_user_list_entry c3m1_available_user_list_entry" 
              >
                <i v-if="userPermissions.includes('a') || userPermissions.includes('v')"
                  @click.stop="addUserToGroup(user)"
                 class="fa fa-plus-circle c3m1_add_user_icon c3m1_add_icon"></i>
                <span class="c3m1_available_user_email">{{user.email}}</span>
              </span>
            </div>
            <div v-else class="c3m1_users_list">
              <beat-loader :loading="true" :color="C_loaderColor" :height="'50px'" :width="'50px'"></beat-loader>
            </div>
          </div>
        </div>
      </div>
    </div>

    <c3m3-manage-group-rules v-if="activeModal=='c3m3' &&
      activeGroup != null && activeOrg != null"
      :orgUid="activeOrg"
      :active-group="activeGroup"
      :subItemsList="subItemsList"
      :parentTitle="modalTitle"
      :activeGroupName="DV_activeGroupName"
      :subItemIndex="subItemIndex +1"
      :parentParams="params"
      :isModal="true"
      @event-close-child-modals="eventCloseChildModals"
      @event-close-modal="eventCloseModal"
      @event-sub-items-change="eventSubItemsChange"
      @event-parameter-change="eventParamsChange"
      @event-sub-items-loaded="eventSubItemsLoaded"
    ></c3m3-manage-group-rules>

  </div>
</template>

<script>
/* eslint-disable */
import ModalHeader from "../../p2ModalHeader";
import { bi10ModalTemplate, bi10OrgPermissions } from "../../../../watchdog_includes/base_i10_UI_mixins";
import getOrgUserPermissions from "../../../../watchdog_includes/json_tasks/p2s7/p2s7t4";
import getNotificationGroupUsers from "../../../../watchdog_includes/json_tasks/p2s7/p2s7t10";
import addUserToNotificationGroup from "../../../../watchdog_includes/json_tasks/p2s9/p2s9t3";
import removeUserFromNotificationGroup from "../../../../watchdog_includes/json_tasks/p2s9/p2s9t4";
import AWN from "awesome-notifications";
import { CR, RC, AJRS } from '../../../../watchdog_includes/base_i2_success_codes'
import bi1_data_validation from '../../../../watchdog_includes/base_i1_datavalidation'
import c3m3ManageGroupRules from './c3m3ManageGroupRules'
import BeatLoader from 'vue-spinner/src/BeatLoader.vue'
import _ from "lodash"

export default {
  name: "c3m1NotificationGroupDetails",
  props: ['activeGroup', 'activeOrg'],
  mixins: [bi10ModalTemplate, bi10OrgPermissions],
  components: {
    ModalHeader,
    c3m3ManageGroupRules,
    BeatLoader
  },
  data: function() {
    return {
      modalTitle:'Loading Group...',
      defaultModal:'default',
      DV_commaSeparatedUserEmails: "",
      DV_notificationGroupMetaData: {},
      DV_activeGroupName: '',
      DV_rawUsersListData: {},
      DV_groupUserJoins: {},
      DV_usersList: [],
      DV_isLoadingUsers: true,
      DV_isLoadingGroupUsersJoin: true,
      DV_ngpUsersLastUpdatedRef: null,
      DV_ngpUsersLastUpdated: 0
    };
  },
  computed: {
    C_loaderColor() {
      return window.G_brand_color;
    },
    C_assignedUsersCount() {
      return _.filter(this.DV_usersList, (user) => user.assigned).length || 0;
    },
    C_availableUsersCount() {
      return _.filter(this.DV_usersList, (user) => !user.assigned).length || 0;
    }
  },
  methods: {
    waitWatchdogReadyCallback() {
      this.DV_notificationGroupMetaData = window.G_watchdog_data.IV_ngp_meta_data;
      this.DV_ngpUsersLastUpdatedRef = window.G_watchdog_data.IV_ngp_users_last_updated;
      this.getUsersList();
      this.getGroupUsersData();
      this.bi10GetOrgPermissions(this.activeOrg);
    },
    getGroupUsersData() {
      this.DV_isLoadingGroupUsersJoin = true;
      this.DV_commaSeparatedUserEmails = "";
      
      getNotificationGroupUsers(
        window.G_firebase_auth.IV_email_address,
        window.G_firebase_auth.IV_id_token,
        [this.activeGroup]
      ).then(
        function(result) {
          this.DV_groupUserJoins = result["group_users"];
          this.updateUsersList();
          this.DV_isLoadingGroupUsersJoin = false;
        }.bind(this)
      );
    },
    getUsersList() {
      getOrgUserPermissions(
        window.G_firebase_auth.IV_email_address,
        window.G_firebase_auth.IV_id_token,
        window.G_watchdog_data.IV_user_info.uid,
        this.activeOrg
      ).then(
        function(result) {
          this.DV_rawUsersListData = result["org_permissions"];
          this.updateUsersList();
        }.bind(this)
      );
    },
    updateUsersList() {
      var raw_users_list = this.DV_rawUsersListData;
      var filtered_users = [];

      for (var key in raw_users_list) {
        var user_email = raw_users_list[key].email;


        // filtering users if DV_commaSeparatedUserEmails filter has some input from user.
        if (this.DV_commaSeparatedUserEmails.length > 0) {
          var emails_list = this.DV_commaSeparatedUserEmails.split(",").map(function(item) {
            return item.trim().toLocaleLowerCase();
          });

           emails_list = emails_list.filter((item) => item.length > 0);

          if (emails_list.find((str) => user_email.toLocaleLowerCase().includes(str)) == undefined) {
            continue;
          }
        }
        //</end> filtering users if DV_commaSeparatedUserEmails filter has some input from user.

        var user_entry = {};
        user_entry.uid = key;
        user_entry.email = user_email;
        user_entry.assigned = false;

        if (this.activeGroup in this.DV_groupUserJoins == true) {
          let users_array = this.DV_groupUserJoins[this.activeGroup];
          if (users_array.includes(user_entry.uid)) {
            user_entry.assigned = true;
          }
        }
        filtered_users.push(user_entry);
      }

      this.DV_usersList = filtered_users;
      this.DV_isLoadingUsers = false;
    },
    removeUserFromGroup(user) {
      var resp = removeUserFromNotificationGroup(
        window.G_firebase_auth.IV_email_address,
        window.G_firebase_auth.IV_id_token,
        window.G_watchdog_data.IV_user_info.uid,
        user.uid.replace("user_","usr_"),
        this.activeGroup
      );
      var vm = this;

      resp.then(
        (res) => {
          this.$awn.success("The request to remove user has been submitted successfully");
        },
        (error) => {
          this.$awn.warning("There was an error removing user from notification group, Please reload the page and try again.");
        } 
      );
    },
    addUserToGroup(user) {
      var resp = addUserToNotificationGroup(
        window.G_firebase_auth.IV_email_address,
        window.G_firebase_auth.IV_id_token,
        window.G_watchdog_data.IV_user_info.uid,
        user.uid.replace("user_", "usr_"),
        this.activeGroup
      );

      var vm = this;
      resp.then(
        (res) => {
          this.$awn.success("The request to add user has been submitted successfully");
        },
        (error) => {
          this.$awn.warning("There was an error adding user to notification group, Please reload the page and try again.");
      });
    },
    addCommaSeparatedUsersToGroup() {
      if (this.DV_commaSeparatedUserEmails == null || this.DV_commaSeparatedUserEmails == "") {
        this.$awn.warning("Please enter user emails in search box first.");
        return;
      }

      // separating out the emails from DV_commaSeparatedUserEmails
      var emails_list = this.DV_commaSeparatedUserEmails.split(",").map(function(item) {
        return item.trim().toLocaleLowerCase();
      });

      emails_list = emails_list.filter((item) => item.length > 0);

      // filtering out the users matching this emails
      var filtered_users_list = this.DV_usersList.filter(function(user) {
        return emails_list.find((str) => user.email.toLocaleLowerCase().includes(str)) != undefined
      })

      let confirmation_message = "<h4>Are you sure you want to Add following users to this group?</h4>";
      confirmation_message += "<ul>";
        for (let index in filtered_users_list) {
          let user = filtered_users_list[index];
          confirmation_message += `<p>${user.email}</p>`;
        }
      confirmation_message += "</ul>";

      var vm = this;
      var confirm_callback_function = function() {
        var add_user_promises = [];

        for (let index in filtered_users_list) {
          let user = filtered_users_list[index];

          let resp = addUserToNotificationGroup(
            window.G_firebase_auth.IV_email_address,
            window.G_firebase_auth.IV_id_token,
            window.G_watchdog_data.IV_user_info.uid,
            user.uid.replace("user_", "usr_"),
            vm.activeGroup
          );
          add_user_promises.push(resp);
        }

        vm.fulfillAddUserPromises(add_user_promises);
      }

      this.$awn.confirm(confirmation_message, confirm_callback_function);
    },
    fulfillAddUserPromises(promises) {
      var popup_options = {
        labels: {
          async: "Adding Bulk users to this Notification Group..",
        },
        duration: 3000,
      };
      let notifier = new AWN(popup_options);

      var vm = this;
      notifier.async(Promise.all(promises),
        (res) => {
          notifier.success(`Users added to Notification Group successfully...`);
          setTimeout(vm.getGroupUsersData, 3000);
        },
        (error) => {
          notifier.alert("There was an error adding some of users to notification group, Please try again reloading the page..");
        } 
      );
    },
    filterUsersList() {
      if (this.DV_commaSeparatedUserEmails == null || this.DV_commaSeparatedUserEmails == "") {
        this.$awn.warning("Please enter user emails in search box first.");
        return;
      }

      this.updateUsersList();
    },
    clearSearch() {
      this.DV_commaSeparatedUserEmails = "";
      this.updateUsersList()
    },
    showManageRules() {
      this.showModal("c3m3");
    }
  },
  watch: {
    DV_ngpUsersLastUpdatedRef: {
      handler() {
        if (!this.DV_ngpUsersLastUpdatedRef || 
            !this.DV_ngpUsersLastUpdatedRef[this.activeGroup]) {
          return;
        }

        if (this.DV_ngpUsersLastUpdatedRef[this.activeGroup] > this.DV_ngpUsersLastUpdated) {
          this.getGroupUsersData();
          this.DV_ngpUsersLastUpdated = this.DV_ngpUsersLastUpdatedRef[this.activeGroup];
        }
      },
      deep: true
    },
    DV_notificationGroupMetaData: {
      handler: function() {
        if (this.activeGroup == undefined || this.activeGroup == null){
          return;
        }

        if (this.activeGroup in this.DV_notificationGroupMetaData == true && 
          'name' in this.DV_notificationGroupMetaData[this.activeGroup] == true) {
          this.DV_activeGroupName = this.DV_notificationGroupMetaData[this.activeGroup]['name'];
        }
      },
      deep: true,
    },
    activeGroup() {
      if (this.activeGroup in this.DV_notificationGroupMetaData == true && 
          'name' in this.DV_notificationGroupMetaData[this.activeGroup] == true) {
        this.DV_activeGroupName = this.DV_notificationGroupMetaData[this.activeGroup]['name'];
      }
    },
    DV_activeGroupName() {
      if (this.modalTitle.includes('Loading Group...') && this.DV_activeGroupName != '') {
        this.actualModalTitle = this.DV_activeGroupName;
        this.modalTitle = this.modalTitle.replace("Loading Group...", this.DV_activeGroupName);
      }
    }
  },
  beforeDestroy() {
    this.params['1-ngp'] = null;
    this.updateParams();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/p2Dashboard/p2s2notifications/p2s2m2/c3m1NotificationGroupDetails.vue